<template>
	<div class="led_box animate__animated animate__fadeIn">
		<div class="led">
			<!-- led详情 -->
			<div class="content_box">
				<div class="content_title">{{ selectData ? selectData.number : '' }}</div>
				<div class="content">
					<div class="content_tab">
						<el-tabs type="border-card">
							<el-tab-pane label="LED基本设置">
								<div class="border_box" v-for="(item, index)  in title" :key="item.id" >
									<el-row>标题设置-{{index+1 }}</el-row>
									<el-form ref="form" label-width="80px">
										<el-form-item label>
											<div class="input_label">内容</div>
											<el-input style="width:80%" placeholder="禁止有换行符" v-model="item.content"></el-input>
										</el-form-item>
									</el-form>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<div class="btn_line" v-if="title&&title.length>0">
					<div class="search-btn orange" @click="fnSaveConfig()"><span>保存</span></div>
				</div>
			</div>
			<div class="data_list">
				<div class="title">LED({{ LedData.length }}台)</div>
				<div class="list_title">
					<div class="title_item">设备编号</div>
					<div class="title_item">在线状态</div>
				</div>
				<div class="list_box">
					<div v-if="LedData">
						<div class="box_line" v-for="(item, index) in LedData" :key="item.id" @click="fnEnvironmentToggle(item, index)" :class="currentLedIndex == index ? 'active' : ''" >
							<div class="line_item">{{ item.number }}</div>
							<div class="line_item">{{ fnOnlineStatusText(item.heartbeatTime).text }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request';
import APP from '@/utils/base';
import { getUserInfo } from '@/utils/auth';
import { getEqptInfo, removeEqptInfo } from '@/utils/auth';
export default {
	data() {
		return {
			projectID: '', // 传递过来的项目信息
			currentLedIndex: 0,// 右侧列表选项
			selectData: [],// 当前显示的数据
			LedData: [], // 扬尘列表
			edid: "", //编辑的id
			title:[],
			basic: {},
			realTime: {},
			statistic: {},
            isIndex: false,
            indexMsg: null,
		}
	},
	created() {
        let _msg = getEqptInfo()
        if(_msg&&_msg.pointType == 'LED设备'){
            this.isIndex = true
            this.indexMsg = _msg.pointNumber
        }
		this.projectID = getUserInfo().id;
		this.fnInit();
	},
    beforeDestroy() {
      removeEqptInfo()
    },
	methods: {
		// 初始化
		fnInit() {
			this.fnGetLedList()
		},
		fnGetLedList(){
			request({
				url: '/led/lists',
				method: 'GET',
				params: {
					project_id: this.projectID
				}
			})
			.then(res => {
				let _data = res.data
				if(_data.length > 0){
					this.LedData = _data
                    // 判断是否首页跳转
                    if(this.isIndex){
                        for(let i in _data){
                            if(_data[i].number == this.indexMsg){
                                this.fnOpenSetWin(_data[i])
                                this.currentLedIndex = i
                            }
                        }
                    }else{
                        this.currentLedIndex = 0
                        // 默认加载第一个数据
                        this.fnOpenSetWin(_data[0])
                    }
				}else{
					this.LedData = []
				}
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 获取选中塔机信息
		fnEnvironmentToggle(_item, _index) {
			this.currentLedIndex = _index;
			this.fnOpenSetWin(_item)
		},
		// 塔机在线状态
		fnOnlineStatusText(_heartbeatTime) {
            let heartbeatTime = new Date(_heartbeatTime);
			return APP.fnOnlineStatusText(heartbeatTime.getTime() / 1000);
		},
		// 保存
		fnSaveConfig() {
			let postdata = ''
			if(this.selectData.config){
				let _basic = JSON.parse(JSON.stringify(this.basic))
				_basic.title = JSON.parse(JSON.stringify(this.title))
				let _data = {
					basic: _basic,
					realTime: JSON.parse(JSON.stringify(this.realTime)),
					statistic: JSON.parse(JSON.stringify(this.statistic))
				}
				postdata = JSON.stringify(_data)
			}
		  request({
		    url: "/led/handle",
		    method: "POST",
		    data: {
		      config: postdata,
		      number: this.edid
		    }
		  })
		    .then(res => {
		      this.$message.success(res.data);
		      this.fnGetLedList();
		    })
		    .catch(err => {
		      this.$message.error(err.data);
		    });
		},

		//初始化页面
		fnOpenSetWin(_data) {
			this.selectData = _data
			this.edid = _data.number
			let _config = _data.config?_data.config:'{}'
			_config = JSON.parse(_config)
			this.basic = _config.basic?_config.basic:{}
			this.realTime = _config.realTime?_config.realTime:{}
			this.statistic = _config.statistic?_config.statistic:{}
			this.title = this.basic?this.basic.title:[]
		},
	}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.led_box{
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.led{
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.content_box{
	position: relative;
	overflow: hidden;
	background-color: rgba(29, 68, 149, 0.1);
	width: 1580px;
	height: 848px;
	margin: 10px 0 0 20px;
	.content_title{
		width: 1580px;
		height: 50px;
		line-height: 50px;
		font-size: 26px;
		text-align: center;
	}
	.content{
		width: 1580px;
		height: 730px;
		position: relative;
		overflow: hidden;
		.content_tab{
			position: absolute;
			left: 0;
			right: -30px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.border_box{
				padding: 5px;
				margin-top: 30px;
				border: 1px dashed #1d4495;
			}
			.input_label{
				min-width: 80px;
				height: 30px;
				line-height: 30px;
				padding: 0 5px;
				display: inline-block;
				text-align: center;
				background-color: rgba(155, 249, 252, 0.1);
			}
			>>>.el-tabs--border-card{
				width: 1580px;
				height: 730px;
				border: none;
				background: transparent;
			}
			>>>.el-tabs--border-card>.el-tabs__header{
				background: url(../../../assets/img/per_list_bg.png) no-repeat;
				background-size: 100% 100%;
				border: none;
			}
			>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item{
				border: none!important;
			}
			>>>.el-tabs__item{
				color: rgba(255,255,255,0.8);
			}
			>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
				color: #409eff;
			}
			>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
				color: #409eff;
				background-color: rgba(0,255,255,0.1);
				border: none!important;
			}
			>>>.el-input{
				width: 220px;
			}
			>>> .el-input__inner {
				width: 220px;
				height: 30px;
				border-radius: 2px;
				border: none;
				color: rgba(77, 180, 244, 0.7);
				background-color: rgba(49, 88, 128, 0.4);
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
		}
	}
	.btn_line{
		width: 1580px;
		height: 68px;
		@include flex-box(center,center);
	}
	>>>.el-switch__core:after{
		content: "";
	}
}
.data_list{
	position: absolute;
	top: 0;
	left: 1620px;
	width: 300px;
	height: 848px;
	margin-top: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.title {
		width: 300px;
		height: 60px;
		font-size: 24px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(center,center);
	}
	.list_title{
		width: 300px;
		height: 48px;
		background: url(../../../assets/img/enter_left_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item{
			width: 96px;
			margin: 0 2px;
			text-align: center;
			&:nth-child(1){
				width: 196px;
			}
		}
	}
	.list_box{
		width: 300px;
		height: 740px;
		.box_line{
			width: 300px;
			height: 48px;
			cursor: pointer;
			border-bottom: 1px dashed #1d4495;
			@include flex-box(center,center);
			&:hover{
				background-color: rgba(49, 88, 128, 0.4);
			}
            &.active{
            	color: #0080FF;
            }
			.line_item{
				width: 96px;
				margin: 0 2px;
				text-align: center;
				&:nth-child(1){
					width: 196px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/LED/ledDefault/index.vue